import { defineStyle } from '@chakra-ui/react';

export const pickVariant = defineStyle({
  boxSize: '48px',
  padding: 0.25,
  color: 'neutral.300',
  border: '2px solid var(--chakra-colors-neutral-600)',
  backgroundColor: 'neutral.800',
  _hover: {
    borderColor: 'skyblue',
  },
  '&[data-active=true]': {
    backgroundColor: 'blue.700',
    borderColor: 'blue',
  },
});
